/** A radio as a card: an icon, a title and a line on what picking it means. */

import type { ReactNode } from "react";

export function ChoiceCard(props: {
  /** The radios' group name. */
  name: string;
  icon: ReactNode;
  checked: boolean;
  disabled?: boolean;
  onPick: () => void;
  note: string;
  children: ReactNode;
}) {
  return (
    <label
      className={`flex cursor-pointer items-start gap-3 rounded-[9px] border p-3.5 transition-[border-color,background-color] has-disabled:cursor-not-allowed has-disabled:opacity-50 ${
        props.checked
          ? "border-link bg-run-bg/40 shadow-[0_0_0_1px_var(--color-link)]"
          : "border-line hover:bg-subtle"
      }`}
    >
      <span
        aria-hidden
        className="flex size-8 shrink-0 items-center justify-center rounded-md bg-chip text-chip-ink"
      >
        {props.icon}
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-[13px] font-semibold text-ink">{props.children}</span>
        <span className="text-xs text-muted">{props.note}</span>
      </span>
      <input
        type="radio"
        name={props.name}
        className="mt-1 size-4 shrink-0 accent-link"
        checked={props.checked}
        disabled={props.disabled ?? false}
        onChange={props.onPick}
      />
    </label>
  );
}
